//admin utility
import { HttpClient, HttpParams } from '@angular/common/http';
declare var $;
import { AfterViewInit, Component, OnInit, ViewChild ,ElementRef} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { MatTable } from '@angular/material/table';
import { _ } from 'underscore';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { EnergyProvidersModalComponent } from '../../admin-utility/energy-providers-modal/energy-providers-modal.component';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import {
  
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

import { ItemsList } from '@ng-select/ng-select/ng-select/items-list';
import { environment } from '../../../environments/environment';
import * as moment from 'moment-timezone';
import { DatePipe } from '@angular/common';
import { Block } from '../../shared/models/block';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators, FormControlName, AbstractControl
} from '@angular/forms';
import { Observable, fromEvent, merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {NgbModal, NgbActiveModal, NgbModule, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';
//import { zipcodeValidator } from './zipcode-validator';


/**
 * @title Table with pagination
 */
@Component({
  selector: 'app-admin-zipcode',
  templateUrl: './admin-zipcode.component.html',
  styleUrls: ['./admin-zipcode.component.css'],
  providers: [DatePipe],
  entryComponents: [SnackbarComponent],
})

export class AdminZipcodeComponent implements OnInit { 


  Status;

  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  modalRef: BsModalRef;
  msg;
  title;
  @ViewChild('SuccessModel', { static: true }) SuccessModel: ElementRef;
  // Use with the generic validation message class
  ZipcodeId;
  pageheadername;
  utilityList;
  managerMaintenanceForm = this.fb.group({
    Zip: new FormControl('', Validators.compose([
      Validators.required,
      Validators.pattern(/^\d{5}$/)
    ])),
    Utility: [, Validators.required],
    City: [, Validators.required],
    State: [, Validators.required],

    
  });

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private residentialService: ResidentialService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private clipboard: Clipboard
  ) {

    

  }

  ngAfterViewInit() {

    this.residentialService.checkAdminLOgin();
  }
  account_validation_messages = {
   
    'Zip': [
      { type: 'required', message: 'The zipcode field is required' },
      { type: 'pattern', message: 'Please enter a valid zipcode.' }
    ],
    'Utility': [
      { type: 'required', message: 'The utility name field is required' },
    ],
    'City': [
      { type: 'required', message: 'The city field is required' },
    ],
    'State': [
      { type: 'required', message: 'The State field is required' },
    ]
    }
    openModal(template: ElementRef<any>) {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
      );
    }

  ngOnInit() {

    this.utilityList = ["CenterPoint Energy","Oncor","AEP Texas Central","Texas-New Mexico Power (TNMP)","AEP Texas North","Lubbock Power and Light"]
    
    $('[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'bottom',
      trigger: 'click'
  });

    $('#AffiliateName').keypress(function( e ) {
      if( e.which == 47 || e.which == 92) 
          return false;
    });
    this.pageheadername = "Add Zip code";
    this.route.params.subscribe(params => {
    
      this.ZipcodeId = params['id']

    });
    
   if(this.ZipcodeId != undefined && this.ZipcodeId != "")
   {
    this.pageheadername = "Edit Zip code";
    this.getAffilationsInfobyId();
   }
    
  
    
  }

  navigateToAnotherComponent() {
    // Use the router to navigate to another component
    this.router.navigate(['/hg-admin-zipcode-list']);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
 

  getAffilationsInfobyId() {
    this.residentialService
      .GetAllZipcodesById(this.ZipcodeId)
      .subscribe((response: any) => {
        // console.log(response);
        if(response.length != 0)
        {
          this.managerMaintenanceForm.setValue({
            Zip: response[0].Zip,
            Utility: response[0].Utility,
            City: response[0].City == undefined ? "" : response[0].City,
            State: response[0].State  == undefined ? "" : response[0].State,
         
          });
          
        }




      });
  }

  valueChanged(event) {
    if (event) {
     
    }
  }
  dateObjectCstFormatted() {
    // return moment(new Date(this.model))
    //   .format('YYYY-MM-DD HH:mm:ss')
    //   .toString();
  }

  AddEditAffilations(form){

    if(!this.residentialService.checkAdminLOgin())
    {

      var UserID;
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.userObj._id) {
        UserID = result.userObj._id;
      } 
    }

    if (this.managerMaintenanceForm.valid) {
     

     
      var AffilationModel = {
        _id: this.ZipcodeId,
        Zip: form.Zip,
        City: form.City,
        State: form.State,
        Utility: form.Utility,
        CreatedBy: UserID,


      };

      this.residentialService
      .SaveZipcodeForm(AffilationModel)
      .subscribe((response: any) => {
        this.msg ="Zipcode has been added successfully";
        if(this.pageheadername.indexOf('Edit') > -1 )
        {
          this.msg ="Zipcode has been updated successfully";
        }
        this.title = this.pageheadername;
        if(response != null && response.code)
        {
          this.msg = response.message;
          this.openModal(this.SuccessModel);
        }
        else
        {
          
          
          this.router.navigate([
            'hg-admin-zipcode-addedit',
            response,
          ]);
  
          this.openModal(this.SuccessModel);
        }
     

      });


    }else
    {
      this.managerMaintenanceForm.markAllAsTouched();
    }

    }

    
  }

}


import { Directive, HostListener } from '@angular/core'; 

@Directive({
  selector: '[appNumericInput]'
})
export class NumericInputDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;

    // Remove non-numeric characters and limit the input to 5 digits
    const numericValue = inputValue.replace(/[^0-9]/g, '').slice(0, 5);

    if (inputValue !== numericValue) {
      inputElement.value = numericValue;
      inputElement.dispatchEvent(new Event('input'));
    }
  }
}